export default {
  /**
   * @desc 作者页面数据
   */
  state: {
    author: [{
      src: require('../assets/close.png'),
      name: '变革家',
      slogan: '帮股权投资者把好第一关！',
      status: true
    }, {
      src: require('../assets/close.png'),
      name: '懂懂笔记',
      slogan: '20年国内财经媒体从业记录者！',
      status: true
    }, {
      src: require('../assets/close.png'),
      name: '变革家',
      slogan: '帮股权投资者把好第一关！',
      status: true
    }, {
      src: require('../assets/close.png'),
      name: '娱乐硬糖',
      slogan: '有温度的泛娱乐产业自媒体。！',
      status: true
    }],
    other: [{
      src: require('../assets/close.png'),
      name: '邝新华',
      slogan: '新周刊主笔',
      status: true
    }, {
      src: require('../assets/close.png'),
      name: '40秒',
      slogan: '认识最疯狂的天才',
      status: true
    }, {
      src: require('../assets/close.png'),
      name: '艾问iAsk',
      slogan: '科技商业价值发现者',
      status: true
    }]
  }
}



// WEBPACK FOOTER //
// ./src/store/AuthorStore.js